export const Logo = ({ compact = false }) => (
  <div data-testid="brand-logo" className="flex items-center gap-3">
    <svg viewBox="0 0 64 64" className={compact ? "h-8 w-8" : "h-10 w-10"} aria-hidden="true">
      <rect width="64" height="64" rx="14" fill="#221629" stroke="rgba(223,186,115,0.35)" />
      <path
        d="M33.5 9c1.2 7.5-7.5 10.2-7.5 18.2a8.6 8.6 0 0 0 17.2 0c0-4.4-2.1-7.4-3.9-10.1 4.8 3.1 8.6 8.2 8.6 14.6A16 16 0 1 1 16 31.7C16 22.5 25.4 19.4 33.5 9z"
        fill="#DFBA73"
      />
      <path
        d="M32 30c.7 4-3.6 5.4-3.6 9.6a4.6 4.6 0 0 0 9.2 0c0-2.3-1.1-3.9-2-5.3 2.5 1.6 4.5 4.3 4.5 7.6a8.1 8.1 0 1 1-16.2.1c0-4.8 4.8-6.4 8.1-12z"
        fill="#F5E3D8"
        opacity="0.85"
      />
    </svg>
    <div className="leading-tight">
      <span className="block font-serif text-lg text-cream">Meno Flames &amp; Finesse</span>
      <span className="block text-[10px] uppercase tracking-[0.3em] text-gold">Reclaim Retreat</span>
    </div>
  </div>
);
